module.exports = __webpack_public_path__ + "static/media/hand-lizard.962c81b3.svg";